export const stsAuthority = "https://localhost:5001/";
export const clientId = "jerelia_web_spa";
export const clientRoot = "https://localhost:5501/";
export const clientScope = "email roles profile openid api1";  
export const apiRoot = "https://localhost:5501/api/";


  